<div class="row">
  <div class="col" style="text-align: center; font-size: 30px;">
    Online Order List
  </div>
  <div class="col-2" style="text-align: right;" (click)="closeClicked()">
    <button mat-button style="background: red; color: white;">Close</button>
  </div>
</div><br>
<div *ngIf="is_data_available">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
  </mat-progress-spinner>
</div>
<div class="row">
  <div class="col">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Delivery Date</th>
          <th>Amount</th>
          <th>Ordered Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of counter_data; let counter_index=index">
          <td>{{ counter_index+1 }}</td>
          <td>{{ data['delivery_date'] }}</td>
          <td>{{ data['online_amount'] | currency: 'INR' }}</td>
          <td>{{ data['order_time'] | date: 'dd-MM-yyyy, h:mm a' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
